<div class="eip">
  <div class="eip-h ei-mono">Import reference links
    <span class="eip-pill muted">manual · references only · never rehosted</span>
  </div>

  <textarea class="eip-urls ei-mono" rows="3" [(ngModel)]="urlsText" name="urlsText"
            placeholder="Paste one or more URLs, one per line (auction, dealer, news, YouTube, social, Getty/Alamy)…"></textarea>

  <div class="eip-row ei-mono">
    <input class="eip-notes" [(ngModel)]="notes" name="importNotes" placeholder="Optional editor note" />
    <label>Suggested use
      <select [(ngModel)]="suggestedUse" name="suggestedUse">
        <option *ngFor="let u of uses" [value]="u">{{ u }}</option>
      </select>
    </label>
    <button class="eip-btn" [disabled]="importing || !urlList.length || !registration" (click)="runImport()">
      {{ importing ? 'Importing…' : 'Import (' + urlList.length + ')' }}
    </button>
  </div>

  <div class="eip-result" *ngIf="result">
    <div class="eip-callout bad ei-mono" *ngIf="result.status === 'error'">{{ result.detail }}</div>
    <ng-container *ngIf="result.status === 'completed'">
      <div class="eip-summary ei-mono">
        Added <b>{{ result.added }}</b> · Deduped <b>{{ result.deduped }}</b> · Failed <b>{{ result.failed }}</b>
      </div>
      <div class="eip-item ei-mono" *ngFor="let r of result.results">
        <ng-container *ngIf="r.ok; else failTpl">
          <span class="eip-pill" [ngClass]="rightsClass(r.rights)">{{ r.rights || '—' }}</span>
          <span class="eip-disp">{{ r.disposition }}</span>
          <img *ngIf="r.thumbnail" class="eip-thumb" [src]="r.thumbnail" alt="" referrerpolicy="no-referrer" />
          <span class="eip-title">{{ r.title || r.url }}</span>
        </ng-container>
        <ng-template #failTpl>
          <span class="eip-pill bad">failed</span>
          <span class="eip-title">{{ r.url }} — {{ r.error }}</span>
        </ng-template>
      </div>
    </ng-container>
  </div>
</div>
